module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/20.c0058323.png";